import React from 'react';
import { Admin, Resource } from 'react-admin';
import dataProvider from '../dataProviderSync';
import { ProductList, ProductEdit, ProductCreate, ProductShow } from './admin/ProductAdmin';
import { Dashboard } from './admin/Dashboard';
import { MyLayout } from './admin/MyLayout';
import { MyLoginPage } from './admin/MyLoginPage';
import { authProvider } from './admin/authProvider';
import UserList from './admin/UserList';
import SalesDashboard from './admin/SalesDashboard';

// Icônes
import InventoryIcon from '@mui/icons-material/Inventory';
import PeopleIcon from '@mui/icons-material/People';
import BarChartIcon from '@mui/icons-material/BarChart';

const MyAdmin = ({ onBackToHome }) => (
  <Admin
    dataProvider={dataProvider}
    authProvider={authProvider}
    dashboard={Dashboard}
    layout={(props) => <MyLayout {...props} onBackToHome={onBackToHome} />}
    loginPage={MyLoginPage}
    title="MyAdmin - La Ferme À L'Ancienne"
  >
    <Resource
      name="products"
      list={ProductList}
      edit={ProductEdit}
      create={ProductCreate}
      show={ProductShow}
      icon={InventoryIcon}
      options={{ label: 'Produits' }}
    />
    <Resource
      name="users"
      list={UserList}
      icon={PeopleIcon}
      options={{ label: 'Utilisateurs' }}
    />
    <Resource
      name="sales"
      list={SalesDashboard}
      icon={BarChartIcon}
      options={{ label: 'Ventes' }}
    />
  </Admin>
);

export default MyAdmin;